"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubscription = void 0;
var react_1 = require("react");
// tslint:disable-next-line max-line-length
function useSubscription(getState, subscriptionKey) {
    var _a = (0, react_1.useState)(undefined), reactState = _a[0], setReactState = _a[1];
    var useEffectInputs = (subscriptionKey === undefined ? [] : [subscriptionKey]);
    (0, react_1.useEffect)(function () {
        setReactState(undefined);
        var unsub;
        // Can't use async/await b/c useEffect must return nothing or an unsub function
        Promise.resolve().then(getState)
            .then(function (state) {
            unsub = state.subscribe(function (value) {
                setReactState(value);
            });
            // We can't know what to do with an error
            // The consumer needs to be sure getState handles any errors and never rethrows
        });
        return function () {
            if (unsub) {
                unsub();
            }
        };
    }, useEffectInputs);
    return reactState;
}
exports.useSubscription = useSubscription;
//# sourceMappingURL=useSubscription.js.map